'use client';

import { Column, Row, Typography } from '@viewup/ui';
import type { ChildrenProps } from 'viewup-lib/common';

export interface LabelWithInputProps extends ChildrenProps {
  isRequired?: boolean;
  label: string;
}

export const LabelWithInput = (props: LabelWithInputProps) => {
  const { label, isRequired = false, children } = props;

  return (
    <Column gap={8}>
      <Row>
        <Typography color='text.primary' fontType='body2.regular'>
          {label}{' '}
          {isRequired && (
            <Typography color='text.error' fontType='body2.regular'>
              *
            </Typography>
          )}
        </Typography>
      </Row>
      {children}
    </Column>
  );
};
